module.exports = __webpack_public_path__ + "img/n3.c5413d4a.png";